/*
 * On megamenu open: measure the active panel's intrinsic content height and
 * set --hds-megamenu-height on .hds-header__pill so the pill grows. On close:
 * reset to 0px and tag .is-closing so CSS can shorten the content fade-out.
 */
(function () {
  const root = document.querySelector('.hds-header');
  if (!root) return;

  const pill = root.querySelector('.hds-header__pill');
  const triggers = root.querySelectorAll('[aria-expanded][aria-controls]');
  if (!triggers.length) return;

  const SAFETY_MS = 500;

  const setHeight = (panel) => {
    if (!pill) return;
    const inner = panel.querySelector('.hds-header__megamenu-inner');
    if (!inner) return;
    pill.style.setProperty('--hds-megamenu-height', inner.scrollHeight + 'px');
  };

  const clearHeight = () => {
    if (!pill) return;
    pill.style.setProperty('--hds-megamenu-height', '0px');
  };

  const handleClose = (panel) => {
    panel.classList.add('is-closing');
    clearHeight();

    let timer = 0;
    const cleanup = () => {
      panel.classList.remove('is-closing');
      pill && pill.removeEventListener('transitionend', onEnd);
      clearTimeout(timer);
    };
    const onEnd = (event) => {
      if (event.target !== pill) return;
      if (event.propertyName === 'height') cleanup();
    };
    pill && pill.addEventListener('transitionend', onEnd);
    timer = setTimeout(cleanup, SAFETY_MS);
  };

  const observer = new MutationObserver((records) => {
    for (const record of records) {
      if (record.attributeName !== 'aria-expanded') continue;
      const trigger = record.target;
      const wasOpen = record.oldValue === 'true';
      const isOpen = trigger.getAttribute('aria-expanded') === 'true';
      if (wasOpen === isOpen) continue;

      const panelId = trigger.getAttribute('aria-controls');
      const panel = panelId ? document.getElementById(panelId) : null;
      if (!panel || panel.getAttribute('data-submenu') !== 'megamenu') continue;

      if (isOpen) {
        setHeight(panel);
        document.dispatchEvent(new CustomEvent('hds:megamenu:opened'));
      } else {
        handleClose(panel);
      }
    }
  });

  triggers.forEach((trigger) => {
    observer.observe(trigger, {
      attributes: true,
      attributeFilter: ['aria-expanded'],
      attributeOldValue: true,
    });
  });
})();
